export default "/kiban/_next/static/images/countSimulationButton-69c768a20f734175c5c16976d34e4b2e.png";